import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AuthCtx = createContext(null);

export function CafeAuthProvider({ children }) {
  const [cafe, setCafe] = useState(null); // null = checking; false = guest; obj = logged in
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/cafe/me");
      setCafe(data);
    } catch {
      setCafe(false);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("soma_cafe_token");
    if (!token) {
      setCafe(false);
      setLoading(false);
      return;
    }
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/cafe/login", { email, password });
    localStorage.setItem("soma_cafe_token", data.access_token);
    setCafe(data.cafe);
    return data.cafe;
  };

  const signup = async (payload) => {
    const { data } = await api.post("/auth/cafe/signup", payload);
    localStorage.setItem("soma_cafe_token", data.access_token);
    setCafe(data.cafe);
    return data.cafe;
  };

  const logout = async () => {
    try { await api.post("/auth/cafe/logout"); } catch {}
    localStorage.removeItem("soma_cafe_token");
    setCafe(false);
  };

  const updateProfile = async (updates) => {
    const { data } = await api.patch("/auth/cafe/me", updates);
    setCafe(data);
    return data;
  };

  return (
    <AuthCtx.Provider value={{ cafe, loading, login, signup, logout, refresh, updateProfile }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useCafeAuth = () => useContext(AuthCtx);
